import { render, staticRenderFns } from "./inspections-and-ca-warnings-list.component.vue?vue&type=template&id=ef9362d0"
import script from "./inspections-and-ca-warnings-list.component.ts?vue&type=script&lang=ts&external"
export * from "./inspections-and-ca-warnings-list.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports